import { forwardRef } from 'react';
import { Assert } from '@team/assert';
import { RootComponent } from '../../../../services/root-component';
import { ItemProps } from '../../types';
import css from './style.module.css';

export const Entry = forwardRef<HTMLButtonElement, ItemProps>(
  function Component({ isSelected = false, onClick, ...props }, forwardedRef) {
    if (import.meta.env.DEV) {
      if (
        [props['aria-label'], props['aria-labelledby']].every(
          Assert.isUndefined
        )
      ) {
        console.warn(
          '[TelegramUi.CompactPagination.Item]: a11y police. Отсутствует один из пропсов: `aria-label` или `aria-labelledby`. Например, "Перейти к слайду 1".'
        );
      }
    }

    const handleClick = isSelected ? undefined : onClick;

    return (
      <RootComponent
        {...props}
        Component="button"
        baseClassName={css.root}
        aria-current={isSelected ? 'true' : undefined}
        ref={forwardedRef}
        onClick={handleClick}
      />
    );
  }
);
